
export function stringify(inputString) {
	if (inputString === undefined) {
		return '';
	}
  let title = '';
  for (let i = 0; i < inputString.length; i++) {
    if (inputString[i] !== '\\') {
      title = title + inputString[i];
    }
  }
  return title;
}



// WEBPACK FOOTER //
// ./assets/src/frontend/helper/helperFunction.js